import { useState } from "react";
import { motion } from "framer-motion";
import { FadeIn } from "../ui/FadeIn";
import { DownloadModal } from "../ui/DownloadModal";

export function HeroSection() {
  const [downloadOpen, setDownloadOpen] = useState(false);

  return (
    <section id="inicio" className="relative overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-top opacity-70"
        style={{ backgroundImage: "url('/fondo-header.png')" }}
        aria-hidden="true"
      />
      <div
        className="absolute inset-0"
        style={{
          background:
            "linear-gradient(180deg, rgba(13, 51, 147, 0.08) 22%, rgba(255, 255, 255, 0.9) 66%, rgba(255, 255, 255, 1) 92%)"
        }}
        aria-hidden="true"
      />
      <div className="section-shell relative pt-28 pb-16 sm:pt-36 sm:pb-24 lg:pt-[20rem] lg:pb-28">
        <FadeIn className="mx-auto max-w-3xl text-center">
          <h1 className="text-3xl font-extrabold leading-tight text-black sm:text-5xl">
            Tu equipo de asistentes virtuales de fútbol
          </h1>
          <p className="mx-auto mt-4 max-w-xl text-base font-medium text-black/85 sm:text-xl">
            Conocé a cada miembro de tu equipo y descubrí cómo pueden potenciar tu
            juego.
          </p>
          <motion.button
            type="button"
            className="btn-primary mt-8"
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
            onClick={() => setDownloadOpen(true)}
          >
            Quiero conocerlos
          </motion.button>
        </FadeIn>
      </div>

      <DownloadModal open={downloadOpen} onClose={() => setDownloadOpen(false)} />
    </section>
  );
}
